<template>
	<div class="att-box">
		<common-field :formSelect="formSelect" :formData="formData">
			<template slot="custom">
				<div class="att-box__item">
					<div class="att-box__item__title">
						<span>默认选项</span>
					</div>
					<el-select v-model="formSelect.defaultValue" placeholder="请选择" size="small" style="width: 100%">
						<el-option :key="-1" label="请选择" value=""></el-option>
						<el-option v-for="(_item, _index) in formSelect.itemList" :key="_index" :label="_item.itemName" :value="_item.itemCode"></el-option>
					</el-select>
				</div>
			</template>
		</common-field>
	</div>
</template>

<script>
import CommonField from "../CommonField";

export default {
	name: "DwRadioConfig",
	components: {
		CommonField,
	},
	props: {
		formData: {
			type: Object
		},
		formSelect: {
			type: Object,
		}
	},
	watch: {
		formSelect: {
			handler() {
				this.$emit('onChangeFormData', this.formData);
			},
			deep: true
		}
	}
};
</script>

<style lang="scss" scoped>
.att-box {
	width: 100%;

	& .att-box__item {
		width: 100%;
		margin-bottom: 24px;
		vertical-align: top;

		&__title {
			margin: 0;
			margin-bottom: 8px;
			
			& > span {
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #182D5C;
				line-height: 14px;
				margin-right: 5px;
			}

			& i {
				font-size: 13px;
				color: #cacad3;
				cursor: pointer;
			}
		}

		&__context {
			& .el-input, & .el-input-number {
				margin-bottom: 8px;
			}
		}
	}

	::v-deep .el-form-item {
		margin-bottom: 24px;

		& > .el-form-item__label {
			padding: 0;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #182D5C;
			line-height: 14px;
			margin-bottom: 8px;
		}
	}
}
</style>